import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isInvoice: 'invoice',
}

export const invoice = createSlice({
    name: 'invoice',
    initialState,
    reducers: {
        isInvoice: (state, action) => {
            state.isInvoice = action?.payload ?? 'invoice';
        },
    },
});

export const { isInvoice } = invoice.actions;
export default invoice.reducer;


